import { DialogActions, DialogContent, DialogContentText } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addAttachmentsToHeader,
    addAttachmentsToLineItem,
} from "redux/actions/createRequisitionActions";
import { baseStyledPaperSX } from "styled/styledSXProperties/styledPaperSX";

import {
    setAvailableAttachmentsToCopyAction,
    setShowAttachmentCopyDialog,
    setShowCopyConfirmDialog,
} from "../../../../redux/actions/attachmentActions";
import { setShowRequisitionDialogue } from "../../../../redux/actions/generalActions";

export default function CopyAttachmentDialog() {
    const dispatch = useDispatch();

    const showDialog = useSelector(
        (state) => state.attachment.showCopyConfirmDialog
    );
    const reqLines = useSelector(
        (state) => state.createRequisition.iBuyRequisition.requisitionLines
    );
    const darkMode = useSelector((state) => state.general.darkMode);

    const requisition = useSelector(
        (state) => state.createRequisition.iBuyRequisition
    );
    const listOfAttachments = [
        ...requisition.requisitionHeaderForm.attachments,
        ...requisition.requisitionLines.flatMap((line) => line.attachments),
    ];

    const handleCopyNo = () => {
        dispatch(setShowCopyConfirmDialog(false));
        dispatch(setShowRequisitionDialogue(true));
        dispatch(addAttachmentsToHeader([]));
        for (let lineNo in reqLines) {
            dispatch(
                addAttachmentsToLineItem(
                    [],
                    reqLines[lineNo]?.attachments[0]?.LINE_NUM
                )
            );
        }
    };

    const handleCopyYes = () => {
        dispatch(setShowCopyConfirmDialog(false));
        dispatch(
            setAvailableAttachmentsToCopyAction(
                listOfAttachments.map((a) => {
                    return { ...a, isSelectedToCopy: false, isCopied: false };
                })
            )
        );
        dispatch(setShowAttachmentCopyDialog(true));
    };

    return (
        <Dialog
            onClose={handleCopyNo}
            open={showDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: baseStyledPaperSX(darkMode) }}
        >
            <DialogContent>
                <Typography variant="h3" marginBottom={"4px"}>
                    Copy attachments?
                </Typography>
                <DialogContentText
                    id="alert-dialog-description"
                    aria-label="Do you want to copy attachments"
                    variant="body1"
                >
                    Do you want to copy attachments with the requisition?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    color="error"
                    // endIcon={<CancelIcon />}
                    onClick={handleCopyNo}
                    aria-label={"No"}
                    sx={{ margin: "16px" }}
                    variant="contained"
                >
                    No
                </Button>
                <Button
                    onClick={handleCopyYes}
                    color="success"
                    // endIcon={<CheckCircleOutlineIcon />}
                    sx={{ margin: "16px" }}
                    variant="contained"
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}
